import React, { Component } from "react";

export class Header extends Component {
  render() {
    return (
      <header
        id="header"
        style={{
          position: "relative",
          color: "#fff",
          backgroundImage: `url(${process.env.PUBLIC_URL + "/img/header-bg.jpg"})`,
          backgroundSize: "cover",
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
          // Use small viewport height for mobile chrome/safari
          height: "100svh",
          minHeight: "560px",
          overflow: "hidden",
        }}
      >
        {/* mobile-only nudge + type scale */}
      <style>{`
  /* small lift on all screens so you can tell it's working */
  #header .intro { transform: translateY(-8px); }

  /* phones + small tablets (covers Pixel 7 comfortably) */
  @media (max-width: 820px) {
    #header .intro {
      transform: translateY(-72px) !important; /* strong nudge up */
      top: auto !important;                     /* ignore previous 'top' */
    }
    #header h1 { font-size: 38px !important; }
    #header .cta { margin-top: 0 !important; }
  }
`}</style>




        {/* --- subtle overlay for readability --- */}
        <div
          className="overlay"
          style={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(to bottom, rgba(0,0,0,.45), rgba(0,0,0,.25))",
            zIndex: 0,
          }}
        />

        {/* --- Content layer --- */}
        <div
          className="intro"
          style={{
            position: "relative",      // enables top:-18px on mobile
            zIndex: 1,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            padding: "0 20px",
            // small universal nudge; keep subtle to avoid overlap
            // top is further adjusted by the media query above on mobile
          }}
        >
          <div className="container">
            <h1
              style={{
                fontWeight: 800,
                fontSize: "56px",
                textShadow: "0 3px 10px rgba(0,0,0,0.4)",
                marginBottom: "18px",
              }}
            >
              Corporate Tax Filing Made Simple
            </h1>

            <p
              style={{
                fontSize: "18px",
                background: "rgba(0, 0, 0, 0.45)",
                color: "#fff",
                padding: "12px 24px",
                borderRadius: "6px",
                display: "inline-block",
                lineHeight: "1.6",
                boxShadow: "0 3px 10px rgba(0,0,0,0.3)",
                marginBottom: "22px",
              }}
            >
              <strong>Flat-Fee T2 Corporate Tax Returns</strong>,{" "}
              <strong>GST/HST Filing</strong>, <strong>and</strong>{" "}
              <strong>Bookkeeping.</strong>{" "}
              <strong>Fast, Accurate, and Remote Across Canada.</strong>
            </p>

            {/* === Buttons === */}
            <div
              className="cta"
              style={{
                marginTop: 8,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "14px",
                flexWrap: "wrap",
              }}
            >
              {[
                { href: "#contact", text: "Get Free Quote" },
                { href: "#services", text: "View Services" },
              ].map((btn, i) => (
                <a
                  key={i}
                  href={btn.href}
                  className="btn btn-custom btn-lg"
                  style={{
                    background:
                      "linear-gradient(90deg, #5eb8ff 0%, #1f7ae0 100%)",
                    border: "2px solid #fff",
                    color: "#fff",
                    boxShadow: "0 3px 10px rgba(0,0,0,0.25)",
                    transition: "all 0.3s ease-in-out",
                    fontWeight: 700,
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background =
                      "linear-gradient(90deg, #1f7ae0 0%, #5eb8ff 100%)";
                    e.target.style.transform = "translateY(-3px)";
                    e.target.style.boxShadow = "0 5px 14px rgba(0,0,0,0.35)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background =
                      "linear-gradient(90deg, #5eb8ff 0%, #1f7ae0 100%)";
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow =
                      "0 3px 10px rgba(0,0,0,0.25)";
                  }}
                >
                  {btn.text}
                </a>
              ))}
            </div>

            <p
              style={{
                fontSize: "15px",
                letterSpacing: "0.3px",
                textShadow:
                  "-1px -1px 2px #000, 1px -1px 2px #000, -1px 1px 2px #000, 1px 1px 2px #000",
              }}
            >
              <strong>
                Same-day responses. No hidden fees. Secure & confidential.
              </strong>
            </p>
          </div>
        </div>
      </header>
    );
  }
}

export default Header;



